import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import type { UseQueryExecute } from "urql"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"
import type { Instruction } from "@/graphql/codegen/graphql"
import InstructionsAssociatedTable from "@/screens/Products/components/Product/Instructions/components/tables/instructionsAssociatedTable"

interface InstructionsContentProps {
  instructions: Instruction[]
  onAddInstruction: () => void
  refetchInstructionsList: UseQueryExecute
  productId: number
}

export const InstructionsContent: FC<InstructionsContentProps> = ({
  instructions,
  onAddInstruction,
  refetchInstructionsList,
  productId,
}) => {
  if (instructions?.length === 0) {
    return (
      <InformationMissingAlert
        title='Start by adding instructions'
        description='No instructions have been added yet. Once you add some, you will be able to see them here.'
        action={
          <Button
            color='inherit'
            size='small'
            appearance='outlined'
            className='text-primary'
            startIcon={<AddOutlined />}
            onClick={onAddInstruction}
          >
            Add Instructions
          </Button>
        }
      />
    )
  }

  return (
    <InstructionsAssociatedTable
      data={instructions}
      productId={Number(productId)}
      refetchInstructionsList={refetchInstructionsList}
    />
  )
}
